
import {UIGameBarbarianInvasion} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGameBarbarianInvasion'
import {UIMGamePlayerInformationDefenderOfColonistView} from './UIMGamePlayerInformationDefenderOfColonistView'
import {UIGamePlayerInformationView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {UIGamePlayerInformationDefenderOfColonistView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationDefenderOfColonistView'

export class UIMGameBarbarianInvasion extends UIGameBarbarianInvasion {
    protected createDefenderOfColonistView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationDefenderOfColonistView {
        return new UIMGamePlayerInformationDefenderOfColonistView(this.uiGameManager, playerInformation)
    }
}
